const ARABIC_SCRIPT_RE = /[\u0600-\u06FF]/u;
const HEBREW_SCRIPT_RE = /[\u0590-\u05FF]/u;
const CYRILLIC_SCRIPT_RE = /[\u0400-\u04FF]/u;
const GREEK_SCRIPT_RE = /[\u0370-\u03FF]/u;
const DEVANAGARI_SCRIPT_RE = /[\u0900-\u0963\u0966-\u097F]/u;
const BENGALI_SCRIPT_RE = /[\u0980-\u09FF]/u;
const THAI_SCRIPT_RE = /[\u0E00-\u0E7F]/u;
const HAN_SCRIPT_RE = /[\u4E00-\u9FFF]/u;
const KANA_SCRIPT_RE = /[\u3040-\u30FF]/u;
const HANGUL_SCRIPT_RE = /[\uAC00-\uD7AF]/u;
const TURKISH_CHAR_RE = /[\u00e7\u011f\u0131\u00f6\u015f\u00fc]/iu;
const TERMINAL_PUNCTUATION_RE = /[.!?\u2026\u061f)"'\]]\s*$/u;
const LEAKY_TBA_TEXT_RE = /\b(the blue alliance|regional winner|final score|winning alliance|match result)\b/i;

const ENGLISH_CUES = ['what ', 'who ', 'where ', 'when ', 'why ', 'how ', 'which ', 'tell me', 'explain', 'define'];
const TURKISH_CUES = [' nedir ', ' ne demek ', ' nasil ', ' nasıl ', ' kim ', ' hangi ', ' neden ', ' kural ', ' otonom ', ' temas ', ' hava '];
const SPANISH_CUES = [' que ', ' como ', ' jueces ', ' presentacion ', ' presentación ', ' autonomo ', ' autónomo ', ' oponente ', ' clima ', ' tiempo ', ' temporada '];
const FRENCH_CUES = [' que ', " qu'est ", ' juges ', ' soumission ', ' presentation ', ' autonome ', ' adversaire ', ' saison ', ' quel temps '];
const GERMAN_CUES = [' wie ', ' wetter ', ' heute ', ' gegner ', ' autonomen ', ' autonomen modus ', ' erlaubt ', ' juroren '];
const ITALIAN_CUES = [' cosa ', " cos'e ", ' che tempo ', ' giudici ', ' presentazione ', ' autonoma ', ' avversario ', ' stagione ', ' consentito ', ' posso ', ' rispondere ', ' solo ', ' domande ', ' sulla ', ' sui '];
const PORTUGUESE_CUES = [' o que ', ' como ', ' juizes ', ' apresentação ', ' apresentacao ', ' autônomo ', ' autonomo ', ' clima ', ' tempo ', ' hoje '];
const INDONESIAN_CUES = [' apa ', ' apa itu ', ' adalah ', ' cuaca ', ' hari ini ', ' juri ', ' presentasi '];
const SWAHILI_CUES = [' ni nini ', ' hali ya hewa ', ' leo ', ' majaji ', ' uwasilishaji '];
const LEADING_LANGUAGE_CUES = {
  en: ['what ', 'who ', 'where ', 'when ', 'why ', 'how ', 'which ', 'tell me ', 'explain ', 'define '],
  tr: ['nedir ', 'ne demek ', 'nasil ', 'kim ', 'hangi ', 'neden '],
  fr: ['combien ', 'que ', "qu'est ", 'quel ', 'quelle ', 'quels ', 'quelles '],
  es: ['como ', 'que ', 'cuanto ', 'quien ', 'cual ', 'cuales '],
  de: ['wie ', 'was ', 'wer ', 'wo ', 'wann ', 'warum ', 'welche ', 'welcher ', 'welches '],
  it: ['cosa ', 'come ', 'quanto ', 'quale ', 'quali ', 'chi '],
  pt: ['o que ', 'como ', 'quanto ', 'quem ', 'qual ', 'quais '],
  id: ['apa ', 'bagaimana ', 'siapa ', 'kapan ', 'mengapa '],
  sw: ['nini ', 'jinsi ', 'kwa nini ', 'nani ', 'lini '],
};

const LANGUAGE_CUES = {
  tr: TURKISH_CUES,
  fr: FRENCH_CUES,
  es: SPANISH_CUES,
  de: GERMAN_CUES,
  it: ITALIAN_CUES,
  pt: PORTUGUESE_CUES,
  id: INDONESIAN_CUES,
  sw: SWAHILI_CUES,
  en: ENGLISH_CUES,
};

const RANKED_LATIN_LANGUAGES = ['tr', 'fr', 'es', 'de', 'it', 'pt', 'id', 'sw', 'en'];
const RTL_LANGUAGES = new Set(['ar', 'fa', 'he', 'ur']);

const WEATHER_CUES = [
  ' weather ',
  ' climate ',
  ' clima ',
  ' tiempo ',
  ' quel temps ',
  ' meteo ',
  ' wetter ',
  ' che tempo ',
  ' hava ',
  ' hava durumu ',
  '\u0637\u0642\u0633',
  '\u05de\u05d6\u05d2 \u05d4\u05d0\u05d5\u05d5\u05d9\u05e8',
  '\u043f\u043e\u0433\u043e\u0434',
  '\u03ba\u03b1\u03b9\u03c1',
  '\u092e\u094c\u0938\u092e',
  '\u0986\u09ac\u09b9\u09be\u0993',
  '\u0e2d\u0e32\u0e01\u0e32\u0e28',
  '\u5929\u6c14',
  '\u5929\u6c17',
  '\ub0a0\uc528',
  '\u0647\u0648\u0627',
  ' cuaca ',
  ' hali ya hewa ',
];

const JUDGING_CUES = [
  ' impact award ',
  ' first impact ',
  ' judges ',
  ' judge ',
  ' judging ',
  ' jueces ',
  ' juges ',
  ' juroren ',
  ' giudici ',
  ' juri ',
  '\u0627\u0644\u062d\u0643\u0627\u0645',
  '\u05e9\u05d5\u05e4\u05d8',
  '\u0441\u0443\u0434\u044c',
  '\u0436\u0443\u0440\u0456',
  '\u03ba\u03c1\u03b9\u03c4',
  '\u091c\u091c',
  '\u0928\u094d\u092f\u093e\u092f\u093e\u0927\u0940\u0936',
  '\u09ac\u09bf\u099a\u09be\u09b0\u0995',
  '\u0e01\u0e23\u0e23\u0e21\u0e01\u0e32\u0e23',
  '\u8bc4\u59d4',
  '\u5be9\u67fb',
  '\uc2ec\uc0ac',
  ' juizes ',
  ' majaji ',
];

const WPILIB_CUES = [
  ' wpilib ',
  ' pidcontroller',
  ' pid controller',
  ' pidsubsystem',
  ' pid subsystem',
  ' odometry',
  ' feedforward',
  ' kinematics',
  ' trajectory',
  ' field relative ',
  ' field oriented ',
  ' open loop ',
  ' closed loop ',
  ' acik cevrim ',
  ' kapali cevrim ',
  '\u03ba\u03bb\u03b5\u03b9\u03c3\u03c4\u03cc\u03c2 \u03b2\u03c1\u03cc\u03c7\u03bf\u03c2',
  '\u0e27\u0e07\u0e08\u0e23',
];

const RULES_CUES = [
  ' autonomous ',
  ' auto ',
  ' autonomous?',
  ' autonomous opponent contact ',
  ' current season ',
  ' this season ',
  ' otonom ',
  ' rakibe ',
  ' temas ',
  ' contact ',
  ' opponent ',
  ' adversaire ',
  ' autonomen ',
  ' autonoma ',
  '\u0627\u0644\u062a\u0634\u063a\u064a\u0644 \u0627\u0644\u0630\u0627\u062a\u064a',
  '\u0627\u0644\u0627\u062d\u062a\u0643\u0627\u0643',
];

const LIVE_TBA_CUES = [
  ' who won ',
  ' winner ',
  ' final score ',
  ' match result ',
  ' rankings ',
  ' regional ',
  ' district ',
  ' championship ',
  ' event history ',
];

const STATS_DEFINITION_CUES = [' opr ', ' dpr ', ' ccwm '];

const LANGUAGE_FALLBACKS = {
  en: 'Sorry, I could not verify a reliable answer for that question right now. Please try again in a moment.',
  tr: 'Uzgunum, bu soru icin su anda guvenilir bir yaniti dogrulayamadim. Lutfen biraz sonra tekrar deneyin.',
  es: 'Lo siento, no pude verificar una respuesta confiable para esa pregunta en este momento. Intentalo de nuevo en un momento.',
  fr: "Desole, je n'ai pas pu verifier une reponse fiable pour cette question pour le moment. Veuillez reessayer dans un instant.",
  de: 'Entschuldigung, ich konnte gerade keine verlassliche Antwort auf diese Frage bestaetigen. Bitte versuche es in einem Moment erneut.',
  it: 'Mi dispiace, al momento non sono riuscito a verificare una risposta affidabile per questa domanda. Riprova tra poco.',
  ar: '\u0639\u0630\u0631\u064b\u0627\u060c \u0644\u0645 \u0623\u062a\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u0625\u062c\u0627\u0628\u0629 \u0645\u0648\u062b\u0648\u0642\u0629 \u0644\u0647\u0630\u0627 \u0627\u0644\u0633\u0624\u0627\u0644 \u062d\u0627\u0644\u064a\u064b\u0627. \u064a\u0631\u062c\u0649 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0628\u0639\u062f \u0642\u0644\u064a\u0644.',
  pt: 'Desculpe, nao consegui verificar uma resposta confiavel para essa pergunta agora. Tente novamente em instantes.',
  he: '\u05de\u05e6\u05d8\u05e2\u05e8, \u05dc\u05d0 \u05d4\u05e6\u05dc\u05d7\u05ea\u05d9 \u05dc\u05d0\u05de\u05ea \u05ea\u05e9\u05d5\u05d1\u05d4 \u05de\u05d4\u05d9\u05de\u05e0\u05d4 \u05dc\u05e9\u05d0\u05dc\u05d4 \u05d4\u05d6\u05d5 \u05db\u05e8\u05d2\u05e2. \u05e0\u05e1\u05d4 \u05e9\u05d5\u05d1 \u05d1\u05e2\u05d5\u05d3 \u05e8\u05d2\u05e2.',
  ru: '\u0418\u0437\u0432\u0438\u043d\u0438\u0442\u0435, \u0441\u0435\u0439\u0447\u0430\u0441 \u044f \u043d\u0435 \u0441\u043c\u043e\u0433 \u043f\u0440\u043e\u0432\u0435\u0440\u0438\u0442\u044c \u043d\u0430\u0434\u0435\u0436\u043d\u044b\u0439 \u043e\u0442\u0432\u0435\u0442 \u043d\u0430 \u044d\u0442\u043e\u0442 \u0432\u043e\u043f\u0440\u043e\u0441. \u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 \u0447\u0435\u0440\u0435\u0437 \u043c\u043e\u043c\u0435\u043d\u0442.',
  uk: '\u0412\u0438\u0431\u0430\u0447\u0442\u0435, \u0437\u0430\u0440\u0430\u0437 \u044f \u043d\u0435 \u0437\u043c\u0456\u0433 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u043d\u0430\u0434\u0456\u0439\u043d\u0443 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u044c \u043d\u0430 \u0446\u0435 \u0437\u0430\u043f\u0438\u0442\u0430\u043d\u043d\u044f. \u0421\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u0437\u0430 \u043c\u0438\u0442\u044c.',
  el: '\u039b\u03c5\u03c0\u03ac\u03bc\u03b1\u03b9, \u03b4\u03b5\u03bd \u03bc\u03c0\u03cc\u03c1\u03b5\u03c3\u03b1 \u03bd\u03b1 \u03b5\u03c0\u03b1\u03bb\u03b7\u03b8\u03b5\u03cd\u03c3\u03c9 \u03bc\u03b9\u03b1 \u03b1\u03be\u03b9\u03cc\u03c0\u03b9\u03c3\u03c4\u03b7 \u03b1\u03c0\u03ac\u03bd\u03c4\u03b7\u03c3\u03b7 \u03c4\u03ce\u03c1\u03b1. \u0394\u03bf\u03ba\u03b9\u03bc\u03ac\u03c3\u03c4\u03b5 \u03be\u03b1\u03bd\u03ac \u03c3\u03b5 \u03bb\u03af\u03b3\u03bf.',
  hi: '\u0915\u094d\u0937\u092e\u093e \u0915\u0930\u0947\u0902, \u092e\u0948\u0902 \u0905\u092d\u0940 \u0907\u0938 \u092a\u094d\u0930\u0936\u094d\u0928 \u0915\u0947 \u0932\u093f\u090f \u0935\u093f\u0936\u094d\u0935\u0938\u0928\u0940\u092f \u0909\u0924\u094d\u0924\u0930 \u0915\u0940 \u092a\u0941\u0937\u094d\u091f\u093f \u0928\u0939\u0940\u0902 \u0915\u0930 \u0938\u0915\u093e. \u0915\u0943\u092a\u092f\u093e \u0925\u094b\u0921\u093c\u0940 \u0926\u0947\u0930 \u092c\u093e\u0926 \u092b\u093f\u0930 \u0915\u094b\u0936\u093f\u0936 \u0915\u0930\u0947\u0902.',
  bn: '\u09a6\u09c1\u0983\u0996\u09bf\u09a4, \u098f\u0987 \u09aa\u09cd\u09b0\u09b6\u09cd\u09a8\u09c7\u09b0 \u099c\u09a8\u09cd\u09af \u098f\u0996\u09a8 \u09a8\u09bf\u09b0\u09cd\u09ad\u09b0\u09af\u09cb\u0997\u09cd\u09af \u0989\u09a4\u09cd\u09a4\u09b0 \u09af\u09be\u099a\u09be\u0987 \u0995\u09b0\u09a4\u09c7 \u09aa\u09be\u09b0\u09bf\u09a8\u09bf. \u0985\u09a8\u09c1\u0997\u09cd\u09b0\u09b9 \u0995\u09b0\u09c7 \u09a5\u09cb\u09a1\u09bc\u09be \u09aa\u09b0\u09c7 \u0986\u09ac\u09be\u09b0 \u099a\u09c7\u09b7\u09cd\u099f\u09be \u0995\u09b0\u09c1\u09a8.',
  th: '\u0e02\u0e2d\u0e2d\u0e20\u0e31\u0e22 \u0e15\u0e2d\u0e19\u0e19\u0e35\u0e49\u0e09\u0e31\u0e19\u0e22\u0e31\u0e07\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e04\u0e33\u0e15\u0e2d\u0e1a\u0e17\u0e35\u0e48\u0e19\u0e48\u0e32\u0e40\u0e0a\u0e37\u0e48\u0e2d\u0e16\u0e37\u0e2d\u0e44\u0e14\u0e49\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49 \u0e42\u0e1b\u0e23\u0e14\u0e25\u0e2d\u0e07\u0e43\u0e2b\u0e21\u0e48\u0e2d\u0e35\u0e01\u0e04\u0e23\u0e31\u0e49\u0e07\u0e43\u0e19\u0e2a\u0e31\u0e01\u0e04\u0e23\u0e39\u0e48',
  zh: '\u62b1\u6b49\uff0c\u6211\u73b0\u5728\u65e0\u6cd5\u9a8c\u8bc1\u8fd9\u4e2a\u95ee\u9898\u7684\u53ef\u9760\u7b54\u6848\u3002\u8bf7\u7a0d\u540e\u518d\u8bd5\u3002',
  ja: '\u3059\u307f\u307e\u305b\u3093\u3002\u73fe\u5728\u3001\u305d\u306e\u8cea\u554f\u306b\u5bfe\u3059\u308b\u4fe1\u983c\u3067\u304d\u308b\u56de\u7b54\u3092\u78ba\u8a8d\u3067\u304d\u307e\u305b\u3093\u3002\u5c11\u3057\u5f8c\u3067\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002',
  ko: '\uc8c4\uc1a1\ud569\ub2c8\ub2e4. \uc9c0\uae08\uc740 \uc774 \uc9c8\ubb38\uc5d0 \ub300\ud55c \uc2e0\ub8b0\ud560 \uc218 \uc788\ub294 \ub2f5\ubcc0\uc744 \ud655\uc778\ud560 \uc218 \uc5c6\uc2b5\ub2c8\ub2e4. \uc7a0\uc2dc \ud6c4 \ub2e4\uc2dc \uc2dc\ub3c4\ud574 \uc8fc\uc138\uc694.',
  fa: '\u0645\u062a\u0623\u0633\u0641\u0645\u060c \u062f\u0631 \u062d\u0627\u0644 \u062d\u0627\u0636\u0631 \u0646\u062a\u0648\u0627\u0646\u0633\u062a\u0645 \u067e\u0627\u0633\u062e \u0642\u0627\u0628\u0644 \u0627\u0639\u062a\u0645\u0627\u062f\u06cc \u0628\u0631\u0627\u06cc \u0627\u06cc\u0646 \u067e\u0631\u0633\u0634 \u062a\u0623\u06cc\u06cc\u062f \u06a9\u0646\u0645. \u0644\u0637\u0641\u0627\u064b \u06a9\u0645\u06cc \u0628\u0639\u062f \u062f\u0648\u0628\u0627\u0631\u0647 \u062a\u0644\u0627\u0634 \u06a9\u0646\u06cc\u062f.',
  id: 'Maaf, saya belum bisa memverifikasi jawaban yang andal untuk pertanyaan itu saat ini. Coba lagi sebentar lagi.',
  sw: 'Samahani, sikuweza kuthibitisha jibu la kuaminika kwa swali hilo kwa sasa. Tafadhali jaribu tena baada ya muda mfupi.',
};

function stripDiacritics(text) {
  return String(text || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '');
}

function normalizeProbe(text) {
  return ` ${stripDiacritics(String(text || ''))
    .toLowerCase()
    .replace(/[\u2018\u2019`]/g, "'")
    .replace(/[^a-z0-9\u0590-\u06ff\u0370-\u03ff\u0400-\u04ff\u0900-\u097f\u0980-\u09ff\u0e00-\u0e7f\u3040-\u30ff\u4e00-\u9fff\uac00-\ud7af'\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()} `;
}

function containsAny(text, phrases) {
  return phrases.some((phrase) => text.includes(phrase));
}

function countMatches(text, phrases) {
  return phrases.reduce((count, phrase) => count + (text.includes(phrase) ? 1 : 0), 0);
}

function dedupe(values) {
  return [...new Set((values || []).filter(Boolean))];
}

function lastScriptMatchIndex(regex, text) {
  let last = -1;
  const flags = regex.flags.includes('g') ? regex.flags : `${regex.flags}g`;
  const globalRegex = new RegExp(regex.source, flags);
  let match = globalRegex.exec(text);
  while (match) {
    last = Math.max(last, match.index);
    match = globalRegex.exec(text);
  }
  return last;
}

function detectArabicScriptLanguage(text) {
  if (!ARABIC_SCRIPT_RE.test(text)) return '';
  if (/[\u067e\u0686\u0698\u06af]|\u0686\u06cc\u0633\u062a|\u0647\u0648\u0627|\u0627\u0645\u0631\u0648\u0632/u.test(text)) {
    return 'fa';
  }
  return 'ar';
}

function detectCyrillicLanguage(text) {
  if (!CYRILLIC_SCRIPT_RE.test(text)) return '';
  if (/[\u0454\u0456\u0457\u0491]|\s\u0449\u043e\s|\s\u044f\u043a\u0430\s|\s\u0441\u044c\u043e\u0433\u043e\u0434\u043d\u0456\s/iu.test(` ${text} `)) {
    return 'uk';
  }
  return 'ru';
}

function detectScriptLanguage(text) {
  const raw = String(text || '');
  const candidates = [
    [lastScriptMatchIndex(ARABIC_SCRIPT_RE, raw), detectArabicScriptLanguage(raw)],
    [lastScriptMatchIndex(HEBREW_SCRIPT_RE, raw), 'he'],
    [lastScriptMatchIndex(CYRILLIC_SCRIPT_RE, raw), detectCyrillicLanguage(raw)],
    [lastScriptMatchIndex(GREEK_SCRIPT_RE, raw), 'el'],
    [lastScriptMatchIndex(DEVANAGARI_SCRIPT_RE, raw), 'hi'],
    [lastScriptMatchIndex(BENGALI_SCRIPT_RE, raw), 'bn'],
    [lastScriptMatchIndex(THAI_SCRIPT_RE, raw), 'th'],
    [lastScriptMatchIndex(KANA_SCRIPT_RE, raw), 'ja'],
    [lastScriptMatchIndex(HANGUL_SCRIPT_RE, raw), 'ko'],
    [lastScriptMatchIndex(HAN_SCRIPT_RE, raw), 'zh'],
  ].filter(([idx, lang]) => idx >= 0 && lang);

  if (!candidates.length) return '';
  candidates.sort((a, b) => b[0] - a[0]);
  if (candidates[0][1] === 'zh') {
    const specificEastAsian = candidates.find(([, lang]) => lang === 'ja' || lang === 'ko');
    if (specificEastAsian) return specificEastAsian[1];
  }
  return candidates[0][1];
}

export function normalizeIntegrAILanguageCode(code) {
  const normalized = String(code || '').trim().toLowerCase();
  if (!normalized) return 'unknown';
  const prefix = normalized.split('-', 1)[0];
  if (/^[a-z]{2,3}$/i.test(prefix)) {
    return prefix;
  }
  return 'unknown';
}

export function detectIntegrAIInputLanguage(text) {
  const raw = String(text || '');
  if (!raw.trim()) return 'unknown';
  const scriptLanguage = detectScriptLanguage(raw);
  if (scriptLanguage) return scriptLanguage;
  if (TURKISH_CHAR_RE.test(raw)) return 'tr';

  const probe = normalizeProbe(raw);
  const normalizedLead = probe.trim();
  const scores = Object.fromEntries(
    RANKED_LATIN_LANGUAGES.map((language) => [language, countMatches(probe, LANGUAGE_CUES[language] || [])])
  );

  if (/^[\u00bf\u00a1]/u.test(raw)) {
    scores.es += 2;
  }

  const topScore = Math.max(...Object.values(scores));
  if (topScore > 0) {
    const tiedLanguages = RANKED_LATIN_LANGUAGES.filter((language) => scores[language] === topScore);
    if (tiedLanguages.length > 1) {
      const leadingCueWinner = tiedLanguages.find((language) =>
        (LEADING_LANGUAGE_CUES[language] || []).some((cue) => normalizedLead.startsWith(cue))
      );
      if (leadingCueWinner) {
        return leadingCueWinner;
      }
    }
    return RANKED_LATIN_LANGUAGES.find((language) => scores[language] === topScore) || 'unknown';
  }

  return 'unknown';
}

export function getIntegrAILanguageDirection(languageCode) {
  const normalized = normalizeIntegrAILanguageCode(languageCode);
  return RTL_LANGUAGES.has(normalized) ? 'rtl' : 'ltr';
}

export function getIntegrAITextDirection(text, languageCode = 'unknown') {
  const normalized = normalizeIntegrAILanguageCode(languageCode);
  if (normalized !== 'unknown') {
    return getIntegrAILanguageDirection(normalized);
  }
  const scriptLanguage = detectScriptLanguage(text);
  return RTL_LANGUAGES.has(scriptLanguage) ? 'rtl' : 'ltr';
}

export function detectIntegrAIAnswerLanguage(text) {
  const detected = detectIntegrAIInputLanguage(text);
  if (detected !== 'unknown') {
    return detected;
  }
  return 'unknown';
}

export function classifyIntegrAIQuestion(text) {
  const raw = String(text || '');
  const probe = normalizeProbe(raw);
  if (!probe.trim()) return 'unknown';
  if (containsAny(probe, WEATHER_CUES)) return 'out_of_scope';
  if (containsAny(probe, STATS_DEFINITION_CUES)) return 'stats_definition';
  if (containsAny(probe, WPILIB_CUES)) return 'wpilib';
  if (containsAny(probe, JUDGING_CUES) && probe.includes('impact')) return 'judging_award';
  if (containsAny(probe, RULES_CUES)) return 'rules_current';
  if (containsAny(probe, LIVE_TBA_CUES)) return 'tba_live';
  return 'generic';
}

export function looksTruncatedIntegrAIAnswer(answer) {
  const trimmed = String(answer || '').trim();
  if (!trimmed) return false;
  if (/\*\*plan:\*\*/i.test(trimmed)) return true;
  if (trimmed.length < 80) return false;
  if (TERMINAL_PUNCTUATION_RE.test(trimmed)) return false;
  return /\b(and|or|because|with|without|during|while|where|which|that|who|when|for|to|de|la|le|el|und|ve|ile)\s*$/iu.test(trimmed);
}

export function getIntegrAIDebugEnabled() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const params = new URLSearchParams(window.location.search || '');
    const queryValue = params.get('integraiDebug') || params.get('debug');
    const storageValue = window.localStorage.getItem('integrai:debug');
    const envValue = process.env.REACT_APP_INTEGRAI_DEBUG || '';
    return ['1', 'true', 'yes', 'on'].includes(String(queryValue || storageValue || envValue).toLowerCase());
  } catch (_err) {
    return false;
  }
}

export function deriveIntegrAISourceTypes(response) {
  return dedupe(
    (response?.sources || []).map((source) => {
      const sourceType = source?.source_type;
      return typeof sourceType === 'string' ? sourceType : '';
    })
  );
}

export function deriveIntegrAISelectedRoute(response) {
  return (
    response?.response_contract?.selected_route ||
    response?.trace?.selected_route ||
    response?.trace?.route ||
    response?.inferred?.route ||
    response?.inferred?.intent ||
    ''
  );
}

export function deriveIntegrAISelectedSourceFamily(response) {
  return (
    response?.response_contract?.selected_source_family ||
    response?.trace?.selected_source_family ||
    response?.inferred?.selected_source_family ||
    ''
  );
}

export function getIntegrAIResponseContract(response) {
  const contract = response?.response_contract;
  if (contract && typeof contract === 'object') {
    return {
      finalAnswerText: String(contract.final_answer_text || response?.answer || ''),
      rawAnswerText: String(contract.raw_answer_text || response?.raw_answer || response?.answer || ''),
      requestedLanguage: String(
        contract.requested_language
        || response?.language?.requested_language
        || response?.language?.user_language
        || ''
      ),
      detectedLanguage: String(
        contract.detected_language
        || response?.language?.detected_language
        || response?.language?.source_language
        || response?.language?.user_language
        || ''
      ),
      outputLanguageValid: contract.output_language_valid !== false,
      answerStatus: String(contract.answer_status || ''),
      selectedRoute: String(contract.selected_route || deriveIntegrAISelectedRoute(response) || ''),
      selectedSourceFamily: String(contract.selected_source_family || deriveIntegrAISelectedSourceFamily(response) || ''),
      canonicalQuery: String(
        contract.canonical_query
        || response?.trace?.canonical_query
        || response?.inferred?.canonical_query
        || response?.language?.canonical_query
        || ''
      ),
      citations: Array.isArray(contract.citations) ? contract.citations : (response?.sources || []),
      translationErrorNonfatal: contract.translation_error_nonfatal || null,
      translationErrorFatal: contract.translation_error_fatal || null,
      frontendRenderSafe: contract.frontend_render_safe !== false,
    };
  }

  const answer = String(response?.final_answer_text || response?.final_answer || response?.answer || '');
  return {
    finalAnswerText: answer,
    rawAnswerText: String(response?.raw_answer_text || response?.raw_answer || answer),
    requestedLanguage: String(response?.language?.requested_language || response?.language?.user_language || ''),
    detectedLanguage: String(response?.language?.detected_language || response?.language?.source_language || response?.language?.user_language || ''),
    outputLanguageValid: response?.language?.output_language_matched !== false,
    answerStatus: '',
    selectedRoute: deriveIntegrAISelectedRoute(response),
    selectedSourceFamily: deriveIntegrAISelectedSourceFamily(response),
    canonicalQuery: String(response?.trace?.canonical_query || response?.inferred?.canonical_query || response?.language?.canonical_query || ''),
    citations: Array.isArray(response?.sources) ? response.sources : [],
    translationErrorNonfatal: null,
    translationErrorFatal: null,
    frontendRenderSafe: true,
  };
}

export function didIntegrAIOutputMatchLanguage(question, answer, response, expectedLanguage = 'unknown') {
  if (typeof response?.response_contract?.output_language_valid === 'boolean') {
    return response.response_contract.output_language_valid;
  }
  if (typeof response?.language?.output_language_matched === 'boolean') {
    return response.language.output_language_matched;
  }
  const expected = normalizeIntegrAILanguageCode(expectedLanguage || detectIntegrAIInputLanguage(question));
  if (!expected || expected === 'unknown' || expected === 'en') {
    return true;
  }
  return detectIntegrAIAnswerLanguage(answer) === expected;
}

export function getLocalizedIntegrAIApology(languageCode) {
  const normalized = normalizeIntegrAILanguageCode(languageCode);
  return LANGUAGE_FALLBACKS[normalized] || LANGUAGE_FALLBACKS.en;
}

export function analyzeIntegrAIResponse(question, response, expectedLanguage = 'unknown') {
  const responseContract = getIntegrAIResponseContract(response);
  const questionClass = classifyIntegrAIQuestion(question);
  const answer = String(responseContract.finalAnswerText || response?.answer || '');
  const selectedRoute = responseContract.selectedRoute || deriveIntegrAISelectedRoute(response);
  const selectedSourceFamily = responseContract.selectedSourceFamily || deriveIntegrAISelectedSourceFamily(response);
  const sourceTypes = deriveIntegrAISourceTypes(response);
  const outputLanguageMatched = didIntegrAIOutputMatchLanguage(question, answer, response, expectedLanguage);
  const translationError = String(
    responseContract.translationErrorFatal
    || response?.language?.translation_error
    || ''
  );
  const tbaLeak = selectedSourceFamily === 'tba_live'
    || sourceTypes.includes('live_data')
    || LEAKY_TBA_TEXT_RE.test(answer);
  const issues = [];

  if (!answer.trim()) {
    issues.push('empty_answer');
  }
  if (
    selectedRoute === 'translation_unavailable'
    || (responseContract.answerStatus === 'unsupported' && Boolean(responseContract.translationErrorFatal))
    || translationError.startsWith('translation_to_en_failed:')
  ) {
    issues.push('translation_unavailable');
  }
  if (!outputLanguageMatched) {
    issues.push('language_mismatch');
  }
  if (looksTruncatedIntegrAIAnswer(answer)) {
    issues.push('truncated_answer');
  }

  if (questionClass === 'out_of_scope') {
    if (selectedSourceFamily && selectedSourceFamily !== 'out_of_scope') {
      issues.push('wrong_source_family');
    }
    if (tbaLeak) {
      issues.push('tba_leak');
    }
  }

  if (questionClass === 'rules_current') {
    if (selectedSourceFamily && selectedSourceFamily !== 'rules_current') {
      issues.push('wrong_source_family');
    }
    if (tbaLeak) {
      issues.push('tba_leak');
    }
  }

  if (questionClass === 'judging_award') {
    if (selectedSourceFamily && selectedSourceFamily !== 'judging_award') {
      issues.push('wrong_source_family');
    }
    if (tbaLeak) {
      issues.push('tba_leak');
    }
  }

  if (questionClass === 'wpilib') {
    if (selectedSourceFamily && selectedSourceFamily !== 'wpilib') {
      issues.push('wrong_source_family');
    }
    if (tbaLeak) {
      issues.push('tba_leak');
    }
  }

  if (questionClass === 'stats_definition' && tbaLeak) {
    issues.push('tba_leak');
  }

  return {
    questionClass,
    selectedRoute,
    selectedSourceFamily,
    sourceTypes,
    outputLanguageMatched,
    tbaLeak,
    answerStatus: responseContract.answerStatus,
    frontendRenderSafe: responseContract.frontendRenderSafe,
    finalAnswerText: responseContract.finalAnswerText,
    rawAnswerText: responseContract.rawAnswerText,
    canonicalQuery: responseContract.canonicalQuery,
    issues,
    valid: issues.length === 0,
  };
}
